import { render, staticRenderFns } from "./ApplicationAliasForm.vue?vue&type=template&id=f44746fa&scoped=true&"
import script from "./ApplicationAliasForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationAliasForm.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAliasForm.vue?vue&type=style&index=0&id=f44746fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44746fa",
  null
  
)

export default component.exports